module.exports = __webpack_public_path__ + "img/card_icon_mantenimiento_catalogo_equipos.545b6c5f.svg";